import Environment from './environment';
import { VIEWPORT_TOP_OFFSET } from './constants';

export const topOfElementIsOffScreen = (el) => {
  if (!el) {
    return false;
  }

  const coords = el.getBoundingClientRect();
  return coords.top < 0 || coords.top > window.innerHeight;
};

export const scrollToElement = (
  element,
  viewportTopOffset = VIEWPORT_TOP_OFFSET
) => {
  if (!element) {
    return;
  }

  const elemRect = element.getBoundingClientRect();
  window.scrollTo(
    elemRect.left,
    elemRect.top + window.pageYOffset - viewportTopOffset
  );
};

// https://css-tricks.com/snippets/javascript/get-url-variables/
export const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

export const getREApiUrl = () => {
  switch (Environment.get()) {
  case 'dev':
    return 'http://localhost:3003/education';
  default:
    return `https://api.${Environment.prefix()}ramseysolutions.com/education`;
  }
};

export const getFDApiUrl = () => {
  switch (Environment.get()) {
  case 'dev':
    return 'http://localhost:3001/api';
  default:
    return `https://www.${Environment.prefix()}foundationsdigital.com/api`;
  }
};
